import i18n from '@/i18n'

export default [
    {
        value: i18n.t('miniCurriculum.form.label.basic'),
        label: i18n.t('miniCurriculum.form.label.basic'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.intermediate'),
        label: i18n.t('miniCurriculum.form.label.intermediate'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.advanced'),
        label: i18n.t('miniCurriculum.form.label.advanced'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.fluent'),
        label: i18n.t('miniCurriculum.form.label.fluent'),
    },
]
